import { GenderEntity } from '../entities/gender-entity';

export default class State {
  loaded = false;

  items: Array<GenderEntity> = [];
}
